<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายการใบ Tax Refund</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
          <div class="title_page ma-3" @click="link('/arin/pos/posinvoicestaxrefundadd')">
            <v-btn type="button" class="btn_add_data" elevation="2" large>สร้างใบ Tax Refund</v-btn>
          </div>
        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px">
          <section class="d-flex justify-space-between">
            <v-row>
              <v-col xs="6" sm="6" md="9" lg="9" xl="9" cols="6" class="content-header-title"> </v-col>
              <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                <div class="mt-1">
                  <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="pa-3">
            <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div class="font-16">{{ dataDetail.item.invoice_code }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.tax_refund_code }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ diffDateTH_Departure(dataDetail.item.doc_date) }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.tourist_name }}</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.credit_charge_status == 1 && dataDetail.item.pay_type.find((o) => o === 3)" class="font-16">
                      {{ formatPrice(parseFloat(dataDetail.item.total_payment) + (parseFloat(dataDetail.item.total_payment) * parseFloat(dataDetail.item.credit_charge)) / 100) }}
                    </div>
                    <div v-else class="font-16">{{ formatPrice(dataDetail.item.total_payment) }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ formatPrice(dataDetail.item.total_vat_refund) }}</div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span>
                        <v-btn
                          elevation="2"
                          class="my-3 mx-1 font-16"
                          outlined
                          color="#8EBBDC"
                          title="ดูรายละเอียด"
                          style="border-radius: 10px"
                          @click="link('/arin/pos/posinvoicestaxrefunddetail/' + dataDetail.item.id)"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </span>
                      <span>
                        <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#FEA06C" title="แก้ไข" style="border-radius: 10px" @click="link('/arin/pos/posinvoicestaxrefundedit/' + dataDetail.item.id)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </span>
                      <span>
                        <v-btn
                          elevation="2"
                          class="my-3 mx-1 font-16"
                          outlined
                          color="#88B358"
                          title="พิมพ์"
                          style="border-radius: 10px"
                          @click="linkPage(dataDetail.item.id)"
                        >
                          <v-icon>mdi-printer</v-icon> พิมพ์
                        </v-btn>
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </section>
        </v-card>
      </div>
      <div v-if="print_taxrefund" class="d-none">
        <iframe :src="'/arin/pos/posinvoicestaxrefundpdf?id=' + print_taxrefund_id" title="print_taxrefund"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_invoices_tax_refund",
  data() {
    return {
      loading_page: false,
      dialog_cancel_order: false,
      search: "",
      print_taxrefund_id: null,
      print_taxrefund: false,
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "เลขที่ใบเสร็จ",
          value: "invoice_code",
          fixed: true,
          width: "120px",
        },
        {
          text: "เลขที่ใบ Tax Refund",
          value: "tax_refund_code",
          fixed: true,
          width: "180px",
        },
        {
          text: "วันที่เอกสาร",
          value: "receipt_date",
          fixed: true,
          width: "120px",
        },
        {
          text: "ชื่อลูกค้า",
          value: "receipt_name",
          fixed: true,
          width: "210px",
        },
        {
          text: "ยอดเงินรวม",
          value: "receipt_sumprice",
          fixed: true,
          width: "130px",
        },
        {
          text: "ยอด Tax refund",
          value: "receipt_refund",
          fixed: true,
          width: "150px",
        },
        {
          text: "จัดการ",
          value: "",
          fixed: true,
          width: "120px",
        },
      ],

      data_list: [],
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "การขาย",
          disabled: false,
        },
        {
          text: "ใบ Tax Refund",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    async linkPage(id) {
      this.print_taxrefund_id = id;
      this.print_taxrefund = await false;
      this.print_taxrefund = await true;
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    diffDateTH_Departure(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]) + 543;
      const final_date = day + "/" + month + "/" + year;
      return final_date;
    },
    link(link) {
      window.location.href = link;
    },
    async getTaxRefundList() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/tax/refund", config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
        }
      });
    },
  },
  mounted() {
    this.getTaxRefundList();
  },
};
</script>

<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88b358 !important;
  border-radius: 10px;
  /* width: 100%; */
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: 45px;
  padding: 0 10px;
}
</style>
